import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import t from '../i18n/fr.json';

const formatDate = (dateStr) => {
  if (!dateStr) return 'TBA';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

export function StatusBadge({ status }) {
  const map    = { live: 'status-live', upcoming: 'status-upcoming', ended: 'status-ended' };
  const labels = { live: t.live, upcoming: t.upcoming, ended: t.ended };
  return <span className={`status-badge ${map[status]}`}>{labels[status]}</span>;
}

// ── Modal de partage ─────────────────────────────────────────────────────────
function ShareModal({ project, onClose }) {
  const [copied, setCopied] = useState(false);
  const url  = `https://onlineico.com/${project.type}/${project.slug}`;
  const type = project.type?.toUpperCase() || 'ICO';
  const desc = project.description ? (project.description.length > 120 ? project.description.substring(0, 117) + '...' : project.description) : '';
  const text = `🚀 Discover "${project.name}" — a new ${type} listed on OnlineICO!\n\n"${desc}"\n\n${url}\n#ICO #IDO #Crypto #Web3`;

  const buttons = [
    {
      label: copied ? 'Copied!' : 'Copy link',
      color: copied ? '#34D399' : '#94a3b8',
      bg:    copied ? 'rgba(52,211,153,0.15)' : 'rgba(255,255,255,0.07)',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
        </svg>
      ),
      action: () => { navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2000); },
    },
    {
      label: 'X (Twitter)',
      color: '#f1f5f9',
      bg:    'rgba(255,255,255,0.07)',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&hashtags=ICO,IDO,Crypto,Web3`,
    },
    {
      label: 'Telegram',
      color: '#60a5fa',
      bg:    'rgba(96,165,250,0.1)',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.17 13.857l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.978.702z"/>
        </svg>
      ),
      href: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    },
    {
      label: 'Reddit',
      color: '#f97316',
      bg:    'rgba(249,115,22,0.1)',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
        </svg>
      ),
      href: `https://reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`,
    },
  ];

  // Aperçu visuel — bannière si dispo, sinon fond coloré avec logo
  const normalizedBanner = project.card_banner_url
    ? (project.card_banner_url.startsWith('http') || project.card_banner_url.startsWith('/')
        ? project.card_banner_url
        : '/' + project.card_banner_url)
    : null;
  const previewBg = normalizedBanner
    ? `url(${normalizedBanner}) center/cover no-repeat`
    : 'linear-gradient(135deg, #0f1e38, #1a2d50)';

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#0d1628', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '24px', width: '100%', maxWidth: '380px',
        boxShadow: '0 32px 80px rgba(0,0,0,0.7)', overflow: 'hidden',
      }}>

        {/* Aperçu visuel */}
        <div style={{ position: 'relative', height: '180px', background: previewBg }}>
          {!normalizedBanner && (
            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
              {project.logo_url
                ? <img src={project.logo_url} alt={project.name} style={{ width: '64px', height: '64px', borderRadius: '16px', objectFit: 'cover', boxShadow: '0 4px 20px rgba(0,0,0,0.5)' }} />
                : <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: '#34D399', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', color: '#050814', fontSize: '1.2rem' }}>
                    {project.name.substring(0, 2).toUpperCase()}
                  </div>
              }
              <div style={{ color: '#f1f5f9', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.1rem' }}>{project.name}</div>
              <div style={{ color: '#475569', fontSize: '0.75rem' }}>onlineico.com</div>
            </div>
          )}
          {normalizedBanner && (
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(13,22,40,0.8) 0%, transparent 60%)' }} />
          )}
          {/* Bouton fermer */}
          <button onClick={onClose} style={{
            position: 'absolute', top: '12px', right: '12px',
            width: '30px', height: '30px', borderRadius: '50%',
            background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.15)',
            color: '#94a3b8', fontSize: '0.85rem', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>
        </div>

        {/* Titre */}
        <div style={{ padding: '20px 24px 6px' }}>
          <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', color: '#f1f5f9', fontSize: '1rem' }}>
            Share this project
          </div>
        </div>

        {/* Aperçu du texte qui sera publié */}
        <div style={{ margin: '10px 24px 0', padding: '12px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px' }}>
          <div style={{ color: '#94a3b8', fontSize: '0.78rem', lineHeight: '1.7' }}>
            🚀 Discover <strong style={{ color: '#f1f5f9' }}>"{project.name}"</strong> — a new {type} listed on OnlineICO!
            <br /><br />
            <span style={{ color: '#cbd5e1', fontStyle: 'italic' }}>"{desc}"</span>
            <br /><br />
            <span style={{ color: '#34D399' }}>onlineico.com/{project.type}/{project.slug}</span>
            <br />
            <span style={{ color: '#475569' }}>#ICO #IDO #Crypto #Web3</span>
          </div>
        </div>

        {/* Boutons ronds */}
        <div style={{ display: 'flex', justifyContent: 'space-around', padding: '20px 16px 28px' }}>
          {buttons.map((b, i) => (
            b.href
              ? <a key={i} href={b.href} target="_blank" rel="noopener noreferrer"
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', textDecoration: 'none', cursor: 'pointer' }}>
                  <div style={{
                    width: '56px', height: '56px', borderRadius: '50%',
                    background: b.bg, border: '1px solid rgba(255,255,255,0.1)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: b.color, transition: 'transform 0.15s, opacity 0.15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                    {b.icon}
                  </div>
                  <span style={{ fontSize: '0.72rem', color: '#64748b', fontWeight: '500' }}>{b.label}</span>
                </a>
              : <button key={i} onClick={b.action}
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                  <div style={{
                    width: '56px', height: '56px', borderRadius: '50%',
                    background: b.bg, border: `1px solid ${copied ? 'rgba(52,211,153,0.3)' : 'rgba(255,255,255,0.1)'}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: b.color, transition: 'transform 0.15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                    {b.icon}
                  </div>
                  <span style={{ fontSize: '0.72rem', color: copied ? '#34D399' : '#64748b', fontWeight: '500' }}>{b.label}</span>
                </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Bouton partage réutilisable ───────────────────────────────────────────────
function ShareButton({ onClick }) {
  return (
    <button
      onClick={e => { e.stopPropagation(); onClick(); }}
      title="Share this project"
      style={{
        display: 'flex', alignItems: 'center', gap: '5px',
        background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '20px', padding: '4px 10px', cursor: 'pointer',
        color: '#94a3b8', fontSize: '0.75rem', fontFamily: 'Inter, sans-serif',
        transition: 'all 0.15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(52,211,153,0.1)'; e.currentTarget.style.color = '#34D399'; e.currentTarget.style.borderColor = 'rgba(52,211,153,0.3)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
      </svg>
      Share
    </button>
  );
}

// ── ProjectCard ───────────────────────────────────────────────────────────────
export default function ProjectCard({ project }) {
  const navigate = useNavigate();
  const [shareOpen, setShareOpen] = useState(false);
  const colors = ['#34D399', '#8B5CF6', '#F59E0B', '#3B82F6', '#EC4899', '#10B981'];
  const color  = colors[project.id % colors.length];

  const firstPrice = project.tokenomics ? (() => {
    try {
      const tok = JSON.parse(project.tokenomics);
      return tok.phases && tok.phases.length > 0 ? tok.phases[0].price : null;
    } catch { return null; }
  })() : null;

  // ── Normalise l'URL de la bannière (relative → absolue depuis la racine)
  const cardBannerUrl = project.card_banner_url
    ? (project.card_banner_url.startsWith('http') || project.card_banner_url.startsWith('/')
        ? project.card_banner_url
        : '/' + project.card_banner_url)
    : null;

  // ── Layout avec bannière image ──────────────────────────────────────────
  if (project.has_card_image && cardBannerUrl) {
    return (
      <>
        {shareOpen && <ShareModal project={project} onClose={() => setShareOpen(false)} />}
        <div className="project-card project-card--banner"
          style={{ borderColor: project.has_premium ? 'rgba(245,158,11,0.35)' : '', cursor: 'pointer' }}
          onClick={() => navigate(`/${project.type}/${project.slug}`)}>

          <div className="card-banner-img">
            <img src={cardBannerUrl} alt={project.name} />
            <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '4px' }}>
              {project.kyc   && <span className="card-overlay-badge card-overlay-badge--kyc">✅ KYC</span>}
              {project.audit && <span className="card-overlay-badge card-overlay-badge--audit">🔒 Audit</span>}
            </div>
            <div style={{ position: 'absolute', bottom: '10px', left: '10px', right: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '0.95rem', color: '#fff', textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}>{project.name}</div>
                <StatusBadge status={project.status} />
              </div>
              <div style={{ fontSize: '0.7rem', color: '#fff', background: 'rgba(0,0,0,0.5)', padding: '2px 8px', borderRadius: '20px', fontWeight: '600' }}>{project.categorie || project.type?.toUpperCase()}</div>
            </div>
          </div>

          <div className="card-banner-body">
            <p className="card-desc" style={{ marginBottom: '12px', WebkitLineClamp: 2 }}>{project.description}</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                {firstPrice
                  ? <div style={{ color: '#34D399', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1rem' }}>${firstPrice}</div>
                  : <div style={{ color: '#94a3b8', fontSize: '0.8rem' }}>Price TBA</div>}
              </div>
              <button className="vote-btn" onClick={e => { e.stopPropagation(); navigate(`/${project.type}/${project.slug}`); }}>
                Details →
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
              <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>Start: <span style={{ color: 'rgba(245,158,11,0.8)' }}>{formatDate(project.presale_start)}</span></div>
              <ShareButton onClick={() => setShareOpen(true)} />
            </div>
          </div>
        </div>
      </>
    );
  }

  // ── Layout standard ──────────────────────────────────────────────────────
  return (
    <>
      {shareOpen && <ShareModal project={project} onClose={() => setShareOpen(false)} />}
      <div className="project-card" style={{ borderColor: project.has_premium ? 'rgba(245,158,11,0.35)' : '' }}>
        <div className="card-glow" style={{ background: color }} />

        <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
          {project.kyc && (
            <span style={{ fontSize: '0.65rem', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: 'rgba(52,211,153,0.12)', color: '#34D399', border: '1px solid rgba(52,211,153,0.3)' }}>
              ✅ KYC
            </span>
          )}
          {project.audit && (
            <span style={{ fontSize: '0.65rem', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: 'rgba(139,92,246,0.12)', color: '#a78bfa', border: '1px solid rgba(139,92,246,0.3)' }}>
              🔒 Audit
            </span>
          )}
        </div>

        <div className="card-top">
          <div className="logo-wrap" style={{ background: project.logo_url ? 'transparent' : color }}>
            {project.logo_url
              ? <img src={project.logo_url} alt={project.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '14px' }} />
              : project.name.substring(0, 2).toUpperCase()
            }
          </div>
          <div className="card-meta">
            <div className="card-name" style={{ cursor: 'pointer', paddingRight: '60px' }} onClick={() => navigate(`/${project.type}/${project.slug}`)}>
              {project.name}
            </div>
            <div className="card-badges" style={{ marginTop: '10px' }}>
              <StatusBadge status={project.status} />
            </div>
          </div>
        </div>

        <p className="card-desc">{project.description}</p>

        <div className="card-footer">
          <div>
            {firstPrice ? (
              <>
                <div style={{ color: '#94a3b8', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '2px' }}>Price</div>
                <div style={{ color: '#34D399', fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.1rem' }}>${firstPrice}</div>
              </>
            ) : (
              <div style={{ color: '#94a3b8', fontSize: '0.82rem' }}>Price TBA</div>
            )}
          </div>
          <button className="vote-btn" onClick={() => navigate(`/${project.type}/${project.slug}`)}>
            Details →
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
          <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
            Start: <span style={{ color: 'rgba(245,158,11,0.8)' }}>{formatDate(project.presale_start)}</span>
          </div>
          <ShareButton onClick={() => setShareOpen(true)} />
        </div>
      </div>
    </>
  );
}
